const PREFIX = 'BTC Direct widget:';

const enum Styling {
    INFO = 'color: #0086ff; font-weight: bold;',
    DEBUG = 'color: #0086ff; font-weight: bold;',
    WARN = 'color: #ffc107; font-weight: bold;',
    DESCRIPTION = 'color: #cccccc;'
}

let debugMode = false;

export const useLogger = (debugging?: boolean) => {
    if (undefined !== debugging) {
        debugMode = debugging;
    }

    const info = (message: string, ...description: string[]): void => {
        log(message, description || null, [Styling.DEBUG]);
    };

    const warn = (message: string, ...description: string[]): void => {
        log(message, description || null, [Styling.WARN]);
    };

    const debug = (message: string, ...description: string[]): void => {
        if (!debugMode) {
            return;
        }

        log(message, description || null, [Styling.DEBUG]);
    };

    function log(message: string, description: string[] | null, styling: string[]): void {
        let msg = `%c${PREFIX} ${message}`;

        if (description && !!description.length) {
            for (const part of description) {
                msg += `\n%c${part}`;
                styling.push(Styling.DESCRIPTION);
            }
        }

        console.log(msg, ...styling);
    }

    return {
        info,
        warn,
        debug
    };
};
